<!-- zoom 通知 -->
<template>
  <div class="notification">
    <div>
      <p>Potential Zoom Error Notification</p>
      <div>
        If you can not open your Zoom link during the Chinese National Day (2019/10/1 - 2019/10/8),<br />
        please re-download the Zoom Application via the link below:
      </div>
      <a href="https://zoom.us/support/download"
         target="_blank">https://zoom.us/support/download</a>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.notification {
  background-color: #fff;
  padding: 24px 0 32px;
  margin-bottom: 36px;
  > div {
    width: 1280px;
    margin: 0 auto;
    overflow: hidden;
    padding-left: 160px;
    > div {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      margin-bottom: 4px;
    }
  }
  p {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 30px;
    margin-bottom: 24px;
  }
  a {
    display: inline-block;
    font-size: 14px;
    color: #6589dd;
    line-height: 24px;
  }
}
</style>
